import {
  IDmMucHoTroNhaNuoc,
  IDmMucHoTroNhaNuocCopyRequest,
  IDmMucHoTroNhaNuocSelectRequest,
} from "../../model/respone/category/IDmMucHoTroNhaNuoc";
import { apiClient } from "../apiClient";

export const MUC_HO_TRO_NHA_NUOC_ENDPOINT = "muc-ho-tro-nha-nuoc";

export const mucHoTroNhaNuocApi = {
  Select: (payload: IDmMucHoTroNhaNuocSelectRequest) =>
    apiClient.post(`${MUC_HO_TRO_NHA_NUOC_ENDPOINT}/select`, payload),
  Save: (payload: IDmMucHoTroNhaNuoc) =>
    apiClient.post(`${MUC_HO_TRO_NHA_NUOC_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${MUC_HO_TRO_NHA_NUOC_ENDPOINT}/${id}`),
  /** Lưu cả lưới một lượt; số tiền <= 0 = bỏ thiết lập của phạm vi đó. */
  Saves: (payload: IDmMucHoTroNhaNuoc[]) =>
    apiClient.post(`${MUC_HO_TRO_NHA_NUOC_ENDPOINT}/saves`, payload),
  /** Sao chép từ kỳ khác sang kỳ đang xem; trả về SỐ DÒNG đã chép. */
  Copy: (payload: IDmMucHoTroNhaNuocCopyRequest) =>
    apiClient.post(`${MUC_HO_TRO_NHA_NUOC_ENDPOINT}/copy`, payload),
};
